export default __webpack_public_path__ + "static/media/splash_anim_1080.bbcbdfe6.webm";